import { cn } from "@theprelude/core";

export const DetectionIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.67383 5.8914C2.55621 3.24299 5.05517 1.3335 8.00007 1.3335C10.9451 1.3335 13.444 3.24299 14.3264 5.8914L13.0611 6.31316C12.3552 4.19442 10.3561 2.66683 8.00007 2.66683C5.64415 2.66683 3.64499 4.19442 2.93908 6.31316L1.67383 5.8914ZM4.20433 6.7349C4.73377 5.14586 6.23314 4.00016 8.00007 4.00016C9.76707 4.00016 11.2664 5.14586 11.7959 6.7349L10.5306 7.15663C10.1777 6.0973 9.17807 5.3335 8.00007 5.3335C6.82213 5.3335 5.82255 6.0973 5.46959 7.15663L4.20433 6.7349Z" />
    <path d="M7.33325 7.3335V9.3335H5.33325V10.6668H7.33325V12.6668H8.66659V10.6668H10.6666V9.3335H8.66659V7.3335H7.33325Z" />
  </svg>
);
